<template>
  <div class="mt-8">
    <div class="intro-y box p-5 mt-5">
      <div class="flex items-center h-10">
        <h2 class="text-lg font-bold truncate mr-5">{{user.name}} 支出费用管理</h2>
        <div class="ml-auto">
          <el-button @click="addHandle" type="primary">新增费用信息</el-button>
        </div>
      </div>
    </div>
    <!-- 新增费用信息弹框 -->
    <el-dialog title="新增支出费用信息" :visible.sync="addFormVisible">
      <el-form :model="addForm" :rules="rules" ref="addForms">
        <el-form-item label="资产出租地址明细:" :label-width="formLabelWidth" prop="assetAddress">
          <el-input v-model="addForm.assetAddress" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="支出金额(元):" :label-width="formLabelWidth" prop="amount">
          <el-input v-model="addForm.amount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="费用类型:" :label-width="formLabelWidth" prop="payType">
          <el-select v-model="addForm.payType" placeholder="请选择">
            <el-option v-for="(item,index) in feeTypes" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支出日期:" :label-width="formLabelWidth" prop="payDate">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="addForm.payDate"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="addForm.payRemark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="backHandle('addForms')">返回</el-button>
        <el-button type="primary" @click="addSubmit('addForms')">提交</el-button>
      </div>
    </el-dialog>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex items-center">
              <div>
                预计支出费用总额
              </div>
              <div class="ml-auto">
                <el-button @click="editHandle" type="primary" size="small">{{editOrShow?'完成':'编辑预计费用'}}</el-button>
              </div>
            </div>
            <div  class="text-2xl font-bold leading-8 mt-4"> 
              <span v-if="!editOrShow">{{ staticData.totalAmount || 0 }}</span>
              <el-input v-else placeholder="请输入费用总额" v-model="staticData.totalAmount"></el-input>
            </div>
            
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                已支出费用总额
              </div>
              <div class="ml-auto">
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4" style="color:red;">{{ staticData.payAmount }}</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                剩余支出费用总额
              </div>
              <div class="ml-auto">
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4">{{ staticData.downAmount }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y mt-8">
      <div class="intro-y box p-5 mt-5 flex items-center">
        <h2 class="text-lg font-bold truncate mr-5">费用明细</h2>
        <div class="ml-auto">
          已支出费用总额：<span style="color:red;">{{staticData.payAmount}}元</span>
        </div>
      </div>
      <!-- table begin-->
      <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table class="table table-report mt-2">
          <thead>
          <tr class="text-gray-700">
            <th class="text-center whitespace-no-wrap">资产出租地址明细</th>
            <th class="text-center whitespace-no-wrap">费用类型</th>
            <th class="text-center whitespace-no-wrap">支出日期</th>
            <th class="text-center whitespace-no-wrap">支出金额</th>
            <th class="text-center whitespace-no-wrap">备注</th>
            <th class="text-center whitespace-no-wrap">费用凭证</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(faker, fakerKey) in datas"
              :key="fakerKey"
              class="intro-x"
          >
            <td class="border-b dark:border-dark-5">
              {{ faker.assetAddress}}
            </td>
            <td class="border-b dark:border-dark-5">
              {{payTypes[faker.payType]}}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.payDate }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.amount}}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.payRemark }}
            </td>
            <td class="border-b dark:border-dark-5">
              <div v-if="faker.voucher" style="display:flex;flex-direction:column;align-items:center;">
                <span>{{faker.voucher.name}}</span>
                <el-button type="text" @click="deleteFile(faker)">删除</el-button>
              </div>
              <el-button v-else type="text" @click="uploadHandle(faker)">上传</el-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!-- table end -->
      <!-- BEGIN: Pagination -->

      <!-- END: Pagination -->
    </div>
    <div class="intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-3"
         style='justify-content: space-between'>
      <el-pagination
          background
          layout="prev, pager, next"
          :page-size='form.perPage'
          :current-page='form.page'
          @current-change='handleTableChange'
          :total="total">
      </el-pagination>
      <select class="border w-20 input box mt-3 sm:mt-0" @change="pageSizeChange">
        <option>10</option>
        <option>25</option>
        <option>35</option>
        <option>50</option>
      </select>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  getCostList,
  // getAssetStatistics,
  saveOrUpdateCost,
  getCostInfo,
  updateTotalAmount,
} from '@/api/workbench.js'
import {mapState} from 'vuex'
import {uploadFile} from '@/assets/js/upload.js'
export default {
  components: {
    // Cascader,
  },
  data() {
    return {
      addFormVisible:false,
      formLabelWidth:'150px',
      addForm:{
        id:'',
        accountId:'',
        assetAddress:'',
        amount:'',
        payType:'',
        payDate:'',
        payRemark:'',
        // voucher:'',
      },
      payTypes:{
        '1':"修缮费",
        '2':"其他费用",
        '3':"物业费",
        '4':"保险费"
      },
      feeTypes:[
        {value:'1',label:"修缮费"},
        {value:'2',label:"其他费用"},
        {value:'3',label:"物业费"},
        {value:'4',label:"保险费"},
      ],
      rules: {
          assetAddress: [
            { required: true, message: '请输入资产出租地址明细', trigger: 'blur' },
          ],
          amount: [
            { required: true, message: '请输入支出金额', trigger: 'blur' },
          ],
          payType: [
            { required: true, message: '请选择费用类型', trigger: 'change' },
          ],
          payDate: [
            {type: 'string', required: true, message: '请选择支出日期', trigger: 'change' },
          ],
      },
      editOrShow:false,
      totalFee:'',
      
      loadingCheck: false,
      loadingSearch: false,
      staticData: {},
      form: {
        accountId:'',
        page: 1,
        perPage: 10,
      },
      total: 0,
      columns: [
        {
          title: '资产出租地址明细',
          dataIndex: 'managementEnterprise',
          key: 'managementEnterprise',
        },
        {
          title: '费用类型',
          dataIndex: 'assetNumber',
          key: 'assetNumber',
        },
        {
          title: '支出日期',
          dataIndex: 'certificateAddress',
          key: 'certificateAddress',
        },
        {
          title: '支出金额',
          dataIndex: 'assetSource',
          key: 'assetSource',
        },
        {
          title: '备注',
          dataIndex: 'contractCount',
          key: 'contractCount',
        },
        {
          title: '费用凭证',
          dataIndex: 'operate',
          key: 'operate',
          scopedSlots: {customRender: 'operate'},
        },
      ],
      datas: [],
    }
  },
  computed: {
    ...mapState({
      user:state=>state.user.user
    })
  },
  methods: {
    backHandle(formName){
      this.$refs[formName].resetFields();
      this.addFormVisible = false;
    },
    addSubmit(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          console.log(this.addForm)
          this.addForm.accountId = this.user.id;
          saveOrUpdateCost(this.addForm).then(res=>{
            let data = res.data
            if(data.code === '000'){
              this.initList();
            }else{
              console.log(data.desc)
            }
          })
          this.addFormVisible = false;
        }else{
          console.log('error submit!!');
          return false;
        }
      })
    },
    uploadHandle(val){
      let para = {
        accountId:val.accountId,
        id:val.id,
        voucher:null,
      }
      uploadFile(10).then(res=>{
        para.voucher = res;
        if(res){
          saveOrUpdateCost(para).then(res=>{
            let data = res.data
            if(data.code === '000'){
              this.initList();
            }else{
              console.log(data.desc)
            }
          })
        }
      })

    },
    deleteFile(val){
      let para = {
        accountId:val.accountId,
        id:val.id,
        deleteVoucher:true
      }
      saveOrUpdateCost(para).then(res=>{
        let data = res.data
        if(data.code === '000'){
          this.initList();
        }else{
          console.log(data.desc)
        }
      })
    },
    onChange(val) {
      this.form.companyId = val[val.length - 1]
    },
    editHandle(){
       if(this.editOrShow){
         let para = {
           accountId:this.user.id,
           amount:this.staticData.totalAmount||0
         }
         if(isNaN(para.amount)){

           return 
         }
         updateTotalAmount(para).then(res=>{
            let data = res.data
            if(data.code === '000'){
              this.getStatic();
              this.editOrShow = false
            }else{
              console.log(data.desc)
            }
         })
       }else{
         this.editOrShow = true
       }
    },
    addHandle(){
      this.addFormVisible = true;
    },
    getStatic() {
      this.loadingCheck = true;
      getCostInfo({accountId:this.user.id}).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.staticData = data.content;
          this.loadingCheck = false;
        } else {
          console.log(data.desc)
        }
      })
    },
    initList() {
      this.loadingSearch = true;
      this.form.accountId = this.user.id;
      getCostList(this.form).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.datas = data.content.list;
          this.datas.map((item, index) => {
            item.index = index;
            return item;
          })
          this.total = data.content.total;
          this.getStatic();
          this.loadingSearch = false;
        } else {
          console.log(data.desc)
        }
      })
    },
    searchHandle() {
      this.form.page = 1;
      this.initList();
    },
    handleTableChange(page) {
      this.form.page = page;
      this.initList();
    },
    pageSizeChange(e) {
      this.form.page = 1;
      this.form.perPage = Number(e.target.value);
      this.initList();
    },
    checkHandle(val) {
      let url=this.$router.resolve({path: '/assetManagement/assetDetail', query: {assetId: val.assetId}}).href
      window.open(url)
    },
  },
  created() {
    this.initList();
    this.getStatic();
  }
};
</script>

